import { render, staticRenderFns } from "./RegistrosPreferenciaTarifaria.vue?vue&type=template&id=a76adbbc&scoped=true&"
import script from "./RegistrosPreferenciaTarifaria.vue?vue&type=script&lang=js&"
export * from "./RegistrosPreferenciaTarifaria.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosPreferenciaTarifaria.vue?vue&type=style&index=0&id=a76adbbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76adbbc",
  null
  
)

export default component.exports